Service = App.loadClass 'core::Angular/Service'
CropYear = App.loadClass 'core::CropYear'

class exports.NSolverService extends Service
    constructor: (@http, @rootScope, @state, @stateParams, @q, @session) ->
        @reset()
        @config = {}
        @year = null
        @crop = null
        @rxMaps = {}
        @configLoaded = @loadConfig()

    reset: () =>
        @surveyId = null
        @survey = null
        @year = null
        @crop = null
        @fields = []
        @currentStepIndex = 0
        @currentStepName = ''
        @brandNew = false
        @nextAttempted = false
        @saving = null
        @triggerBrowserWarning = true
        @loadNMaps()

    loadNMaps: () =>
        @http.get "api/nitrogen-rx-maps?year=#{new CropYear().get()}"
        .then (response) =>
            for map in response.data
                @rxMaps[map.fields_id] = map

    loadConfig: () =>
        @http.get('backend/grower/nsolver/config').then (response) =>
            @config = response.data

    createSurvey: (year, crop) =>
        @year = year
        @crop = crop

        @http.post 'api/nitrogen-surveys', {
            crops_id: crop
            companies_id: @session.get 'SelectedCompany-grower'
            year: year
        }
        .then (response) =>
            @survey = response.data
            @crop = @survey.crop.name
            return response

    gotoStep: (stepNumber, id, saveData = true) =>
        if not id
            id = @stateParams.id

        if not id
            throw new Error("N Solver: Going to step #{stepNumber} but no survey id specified!")

        if saveData
            @save id

        @currentStepIndex = stepNumber
        @currentStepName = _.findKey @config.steps, (obj) =>
            obj.order is stepNumber

        # Make sure that visited_steps has been loaded before we try to mark the step as visited
        if @currentStepName
            currentStepName = @currentStepName
            @survey.visited_steps.push currentStepName
            @survey.visited_steps = _.uniq(@survey.visited_steps)

        @nextAttempted = false

        @state.go 'grower.nsolver.step', { id: id, step: stepNumber + 1 }

    findStepIndexByName: (stepName) =>
        @config.steps[stepName]['order']

    save: (id) =>
        if not @survey
            return

        if @currentStepName
            @survey.saved_steps.push @currentStepName
            @survey.saved_steps = _.uniq(@survey.saved_steps)

        for fieldSurvey in @survey.fields_nitrogen_surveys
            fieldSurvey.complete = @fieldSurveyComplete fieldSurvey

        @saving = @http.put "api/nitrogen-surveys/#{id}", @survey
        .then (response) =>
            if @survey
                for fieldSurvey in response.data.fields_nitrogen_surveys
                    _.find @survey.fields_nitrogen_surveys, { fields_id: fieldSurvey.fields_id }
                    .events = fieldSurvey.events

    fillFieldSurveys: (inputName, value) =>
        for fieldSurvey in @survey.fields_nitrogen_surveys
            fieldSurvey.data[inputName] = value

    #####################################
    # Custom widget completion logic
    #####################################
    eventsWidgetComplete: (fieldSurvey) =>
        fieldSurvey.events.planting.length

    #####################################
    # /Custom widget completion logic
    #####################################
    inputSet: (inputName, fieldSurvey) =>
        fieldSurvey.data[inputName] isnt undefined and fieldSurvey.data[inputName] isnt null

    inputComplete: (inputName, fieldSurvey) =>
        if inputName is 'standing_residue' and fieldSurvey.data['tillage_practice'] isnt 'No-Till'
            return true

        if inputName is 'historical_yield'
            return "#{fieldSurvey.data[inputName]}" is "#{+fieldSurvey.data[inputName]}" and +fieldSurvey.data[inputName] < 1000

        @inputSet inputName, fieldSurvey

    allInputsComplete: (config, fieldSurvey) =>
        _.every config, (inputConfig, inputName) =>
            inputConfig.value.required?.value isnt true or @inputComplete inputName, fieldSurvey

    stepCompleteForFieldSurvey: (stepName, fieldSurvey) =>
        _.every @config.steps[stepName].value, (widgetConfig, widgetName) =>
            if widgetName is 'events'
                return @eventsWidgetComplete fieldSurvey

            @allInputsComplete widgetConfig.value, fieldSurvey

    fieldSurveyComplete: (fieldSurvey) =>
        _.every @config.steps, (stepConfig, stepName) =>
            @stepCompleteForFieldSurvey stepName, fieldSurvey

    surveyComplete: (survey = @survey) =>
        if not survey
            return true

        _.every survey.fields_nitrogen_surveys, (fieldSurvey) =>
            @fieldSurveyComplete fieldSurvey

    stepComplete: (stepName, survey = @survey) =>
        if not survey
            return false

        survey.fields_nitrogen_surveys.length and _.every survey.fields_nitrogen_surveys, (fieldSurvey) =>
            @stepCompleteForFieldSurvey stepName, fieldSurvey
